import { useCallback, useEffect, useState } from 'react'
import {
  type CompletionItem,
  countUnseen,
  getSeenAt,
  NOTIF_CHANGED_EVENT,
  NOTIF_SEEN_EVENT,
} from '@/lib/completions'

// Hitung notifikasi "penyelesaian" yang belum dilihat + realtime via SSE.
// Komponen pemakai (sidebar) jadi SUMBER SSE tunggal: saat ada perubahan, ia
// me-relay window event NOTIF_CHANGED_EVENT supaya halaman ikut refresh tanpa
// koneksi SSE ganda.
export function useNotifCount(): number {
  const [count, setCount] = useState(0)

  const refresh = useCallback(async () => {
    try {
      const res = await fetch('/api/completions')
      if (!res.ok) return
      const d = await res.json()
      const items: CompletionItem[] = Array.isArray(d.items) ? d.items : []
      setCount(countUnseen(items, getSeenAt()))
    } catch {
      /* abaikan */
    }
  }, [])

  useEffect(() => {
    refresh()

    let debounce: ReturnType<typeof setTimeout> | null = null
    const onChange = () => {
      if (debounce) clearTimeout(debounce)
      debounce = setTimeout(() => {
        void refresh()
        window.dispatchEvent(new Event(NOTIF_CHANGED_EVENT)) // relay ke halaman
      }, 300)
    }

    let es: EventSource | null = null
    try {
      es = new EventSource('/api/realtime')
      es.addEventListener('change', onChange)
    } catch {
      /* SSE tak tersedia → andalkan polling */
    }

    const interval = setInterval(() => {
      if (document.visibilityState === 'visible') refresh()
    }, 45000)

    const onSeen = () => setCount(0) // halaman ditandai sudah dilihat
    window.addEventListener(NOTIF_SEEN_EVENT, onSeen)

    return () => {
      if (debounce) clearTimeout(debounce)
      clearInterval(interval)
      window.removeEventListener(NOTIF_SEEN_EVENT, onSeen)
      es?.close()
    }
  }, [refresh])

  return count
}
